import { useState, useEffect } from "react";
import { ShieldCheck, X, FileText } from "lucide-react";

const CERT = "/masaya-insurance.jpg";

export default function InsuranceSection() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    if (open) { document.addEventListener("keydown", onKey); document.body.style.overflow = "hidden"; }
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [open]);

  return (
    <section className="bg-[#1E1A17] py-20" data-testid="insurance-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#B87333]">
              <ShieldCheck size={16} /> Insured
            </span>
            <h2 className="mt-3 font-serif text-3xl sm:text-4xl text-white">Insured Cleaning Professionals</h2>
            <p className="mt-4 text-[#B8AE9C] leading-relaxed">
              Masaya Hospitality Cleaning Services LLC carries general liability and workers' compensation insurance for the protection of our clients, properties, and team.
            </p>
            <button
              onClick={() => setOpen(true)}
              className="mt-6 inline-flex items-center gap-2 bg-[#B87333] hover:bg-[#A06127] text-white font-medium rounded-full px-6 py-3 shadow-md transition-colors"
              data-testid="view-insurance-btn"
            >
              <FileText size={18} /> View Proof of Insurance
            </button>
            <p className="mt-5 text-sm text-[#8E867A]">
              Detailed certificates of insurance are available to clients and property managers upon request.
            </p>
          </div>

          <button
            onClick={() => setOpen(true)}
            className="group relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl bg-white/5 focus:outline-none focus:ring-2 focus:ring-[#B87333]"
            aria-label="View proof of insurance certificate"
            data-testid="insurance-preview"
          >
            <img
              src={CERT}
              alt="Masaya Hospitality Cleaning Services proof of insurance certificate"
              className="w-full h-64 sm:h-80 object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
              loading="lazy"
            />
            <span className="absolute inset-0 flex items-center justify-center bg-[#1E1A17]/30 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="bg-white/90 text-[#2C2621] text-sm font-medium rounded-full px-4 py-2 inline-flex items-center gap-2"><FileText size={15} /> View certificate</span>
            </span>
          </button>
        </div>
      </div>

      {open && (
        <div
          className="fixed inset-0 z-[80] flex items-center justify-center bg-black/80 p-4"
          onClick={() => setOpen(false)}
          role="dialog"
          aria-modal="true"
          data-testid="insurance-modal"
        >
          <button
            onClick={() => setOpen(false)}
            className="absolute top-4 right-4 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center"
            aria-label="Close"
            data-testid="insurance-modal-close"
          >
            <X size={22} />
          </button>
          <img
            src={CERT}
            alt="Masaya Hospitality Cleaning Services proof of insurance certificate"
            className="max-w-full max-h-[88vh] rounded-xl shadow-2xl object-contain"
            onClick={(e) => e.stopPropagation()}
            onContextMenu={(e) => e.preventDefault()}
            draggable={false}
          />
        </div>
      )}
    </section>
  );
}
